<template>
  <footer id="footer" class="footer" v-if="!isLinksMode">
    <div id="ftBottom" class="level">
      <div class="container x-copyright">
        ©
        <abbr title="JAPAN AUTOMOBILE FEDERATION"></abbr>. All rights
        reserved.</div
      >
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {}
  },
  computed: {
    isLinksMode() {
      if (this.$store.state.auth.userType == '80' && this.$store.state.auth.loggedIn) {
        return true
      }

      return false
    },
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style lang="scss" scoped>
.footer {
  border-top: none;
  background: #eee;
  padding: 0;
  display: block;
  width: 100%;
  margin-top: 10px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1232px;
  min-width: 1022px;
  margin: 0 auto;
  padding: 0 12px;
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}

.container {
  padding: 0 12px;
}

#ftBottom {
  // background: #d80038;
  background: white;
  color: #0a0044;
  padding: 2em 0 3em;
}
#ftBottom .container {
    display: block;
    font-size: .9375em;
    box-sizing: border-box;
    text-align: center;
}
#ftBottom abbr {
    text-decoration: none;
}
#ftBottom abbr::before {
      content: attr(title);
}

@media screen and (max-width: 767px) {
  #ftBottom {
    text-align: center;
    padding: 1em 0 10px;
  }
  #ftBottom .container {
    max-width: 100%;
    min-width: 100%;
    padding: 0 0.667em;
  }
  #ftBottom .pc {
    display: none;
  }
}
</style>
